import {Component, Input, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {Subscription} from 'rxjs';
import {Broadcaster} from 'src/app/app.broadcast';
import {Constants} from '../../../shared/utils/constants';

@Component({
  selector: 'fx-profit-portfolio',
  templateUrl: './profit-portfolio.component.html',
  styleUrls: ['./profit-portfolio.component.sass'],
})
export class ProfitPortfolioComponent implements OnInit {
  @Input() title;
  @Input()
  set channels(val) {
    this.channel = val;
    this.listExchange = Constants[this.channel].filter(v => !['total', 'wallet'].includes(v.value));
  }
  @Input() total: Record<string, number>;
  @Input() currency: string;
  subscription: Subscription;
  listExchange = [];
  channel = 'EXCHANGES';
  constructor(
    private service: DashboardService,
    private broadcaster: Broadcaster
  ) {
    this.broadcaster
      .on('UPDATED_PROFIT_TIMESTAMP')
      .subscribe((data: number) => {
        // this.condition.timestamp = data;
        // this.getData();
      });
  }

  ngOnInit(): void {
  }
}
